
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 12","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.788.135a.462.462 0 00-.653.653L5.347 6 .135 11.212a.462.462 0 10.653.653L6 6.653l5.212 5.212a.461.461 0 10.653-.653L6.653 6 11.865.788a.461.461 0 10-.653-.653L6 5.347.788.135z"}})])
          )
        }
      }
    